var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemStatusOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 0C10.8659 0 14 3.13402 14 6.99985C14 10.8657 10.8659 13.9997 6.99999 13.9997C3.13408 13.9997 0 10.8657 0 6.99985C0 3.13402 3.13408 0 6.99999 0Z",
    fill: "#474F64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00039 1.90869C9.81099 1.90869 12.086 4.18895 12.086 6.99949C12.086 9.81004 9.81099 12.0903 7.00039 12.0903C4.18979 12.0903 1.91479 9.81004 1.91479 6.99949C1.91479 4.18895 4.18979 1.90869 7.00039 1.90869Z",
    fill: "#32C832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemStatusOn);
export default __webpack_public_path__ + "static/media/item-status-on.f1f4c75189fca94be2a32c5e3d7ea178.svg";
export { ForwardRef as ReactComponent };